<template>
  <div class="test-result">
    <HeadedContainer padded>

      <template v-slot:header>
        {{$ml.get(`TISSUE TEST RESULT`)}}
      </template>

      <div class="body" v-if="loaded">

          <div class="item head">
            <div class="side nut"><b>{{ $ml.get(`Nutrients`) }}</b></div>
            <div class="side unit"><b>{{ $ml.get('Unit') }}</b></div>
            <div class="side"><b>{{ $ml.get(`Value`) }}</b></div>
            <div class="side interpretation"><b>{{ $ml.get(`Interpretation`) }}</b></div>
          </div>

          <TestResultNutrientItem
            v-for="item in nutrients"
            :item="item"
            v-model="$store.getters['tests/tissue/getDataRowByNutrient'](item.key).value"
          />

      </div>
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import DropList from '@/components/common/DropList'
import TestResultNutrientItem from './TestResultNutrientItem'

export default {
  components: {
    HeadedContainer,
    DropList,
    TestResultNutrientItem,
  },
  data() {
    return {

    }
  },
  created(){
    // console.log(this.$store.getters['nutrients/data']);
  },
  computed: {
    data() {
      return this.$store.getters['tests/tissue/form'].data;
    },
    loaded() {
      return this.data.length;
    },
    nutrients () {
      return this.$store.getters['nutrients/data'].filter(item => item.key != 'HCO3');
    }
    // nForms() {
    //   return this.data.filter(n => n.n_form);
    // },
    // microNutrients() {
    //   return this.data.filter(n => !n.n_form);
    // },
  }
}
</script>

<style lang="scss" scoped>

.test-result {



  .body {
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    .item, .item::v-deep {
      border-bottom: 1px solid #E4E5E6;
      height: 60px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      &.head {
        .side {
          b {
            text-transform: uppercase;
            // &:first-letter {
            //   text-transform: uppercase;
            // }
          }
        }
      }
      .side {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        // flex-grow: 1;
        flex-basis: 25%;

        &.nut {
          .as-default {
            padding: 8px 12px;
          }
        }
        &.unit {
          flex-basis: 10%;
        }
        &.interpretation {
          flex-grow: 1;
          padding-left: 16px;
        }
        &.value {
          color: $mainGreen;
          font-size: 16px;

          input {
            color: $mainGreen;
            font-size: 16px;
          }
        }
        &.interpretation {
          font-weight: bold;
          &.adequate {
            color: #A7B975;
          }
          &.high {
            color: #F2B14E;
          }
          &.low {
            color: #5EC19B;
          }
          &.excessive {
            color: #EC5A60;
          }
          &.none {
            color: #8B8D91;
          }
        }
      }
      @media(max-width:768px) {
        flex-wrap: wrap;
        padding-top: 8px;
        height: auto;
        .side {
          &.nut {
            width:80px;
          }
          &.value {
            flex-grow: 1;
            padding: 0 8px 0 24px;
            input {
              width: 100%!important;
              height: calc(100% - 8px);
              border: 1px solid #e0e0e0;
              padding: 4px;
              box-sizing: border-box;
            }
          }
          &.interpretation {
            flex-basis: 100%;
            padding: 16px;
          }
        }
      }
    }

  }
}

</style>
